import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { RadioGroup, RadioGroupItem } from "@air/primitive-radio-group";
import { memo } from "react";
const options = [
    {
        id: "this-board",
        label: "This board only"
    },
    {
        id: "with-descendants",
        label: "This board and all sub-boards"
    }
];
export const ConnectedToSlackToggles = /*#__PURE__*/ memo((param)=>{
    let { canManageSlackIntegration, integration, boardId, onUpdate } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "mt-2 rounded-6 border border-grey-5 bg-grey-3 px-4 py-3",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "text-12 font-medium text-grey-12",
                children: "Send notifications for:"
            }),
            /*#__PURE__*/ _jsx(RadioGroup, {
                className: "mt-2 gap-2",
                value: integration.includeDescendants ? "with-descendants" : "this-board",
                disabled: !canManageSlackIntegration || integration.isCoveredByAncestor,
                onValueChange: (value)=>onUpdate({
                        receiverId: integration.receiverId,
                        boardId,
                        includeDescendants: value === "with-descendants",
                        integrationId: integration.integrationId,
                        channelName: integration.channelName
                    }),
                children: options.map((param)=>{
                    let { id, label } = param;
                    return /*#__PURE__*/ _jsx(RadioGroupItem, {
                        id: id,
                        value: id,
                        className: "text-14 text-grey-12 [&>label]:w-full",
                        children: label
                    }, id);
                })
            })
        ]
    });
});
ConnectedToSlackToggles.displayName = "ConnectedToSlackToggles";
